import React, { useMemo } from "react"
import {
  faPhone,
  faLocationDot,
  faCheckDouble,
  faChevronRight, 
  faMapLocationDot,
  faIndianRupeeSign,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useNavigate } from "react-router-dom" 
import { useDispatch, useSelector } from "react-redux"
import {
  Button,
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Snippet,
  useDisclosure,
} from "@heroui/react"
import copy from "clipboard-copy"

import {   COLUMN_ALIGN_TYPE, FOOTER_TYPE, ROW_ACTION_BTN_TYPE } from "../../../components/NextUITable.jsx"
import { apiRoute, linksUrl, outTypeEnum } from "../../../constants/enum"
import { calculateTotal } from "../../../Utility/utility"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
} from "../../../components"
import { useFetchWithBody, usePost } from "../../../api/reactQueryCustomHooks.jsx"
import { setCurrentParty } from "../../../state/outstandingPayableSlice.jsx"

const OutPPartySummary = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { compCode } = useSelector((state) => state.company)
  const { partySummary } = useSelector((state) => state.outstandingPayable)

  const {
    isOpen: isOpenAddressModel,
    onOpen: onOpenAddressModel,
    onOpenChange: onOpenAddressModelChange,
  } = useDisclosure()

  

 
  const exportColumns = [
    { uid: "party", name: "Party" },
    { uid: "Balance_Amount", name: "Balance Amount", type: "number" },
  ]
  const { isLoading, isError:isErrorFetch, data=[] } = useFetchWithBody({
    url: apiRoute.outstanding.partySummary,
    queryKey: "OutstandingPayablePartySummary",
    inputData: {
      compcode: compCode.join(","),
      out_type: outTypeEnum.G,
    },
  })
  const {
    isPending: isAddressPending,
    isError,
    data: addressData=[],
    mutate: fetchAddress,
  } = usePost({
    url: apiRoute.outstanding.partyInfo,
    queryKey: "OutstandingPayablePartySummary-Address",
  })

  const INITIAL_VISIBLE_COLUMNS = ["party", "actions"]

  const totalBalanceAmount = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "Balance_Amount",
      }),
    [data]
  )
  let downloadDataFooter = {
    party: "",
    Balance_Amount: "Total: " + totalBalanceAmount,
  }

  const columns = [
    {
      name: "Party Name",
      uid: "party",
      sortable: true,
      secondCol: {
        name: "Balance_Amount",
        icon: <FontAwesomeIcon icon={faIndianRupeeSign} size="sm" />,
      },
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalBalanceAmount,
      },
    },
    {
      name: "Balance Amount",
      uid: "Balance_Amount",
    },
    {
      name: "ACTIONS",
      uid: "actions",
     // align:COLUMN_ALIGN_TYPE.center,
    },
  ]

  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon icon={faLocationDot} />,
      onClick: (row) => {
        fetchAddress({
          data: {
            compcode: compCode.join(","),
            party_id: row.party_id,
          },
        })
        onOpenAddressModel()
      },
      label: "Address",
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon icon={faChevronRight} />,
      onClick: (row) => {
        
        dispatch(setCurrentParty(row))
        navigate(linksUrl.outstanding.payable.partyAgingSummary)
      },
      label: "next",
      type: ROW_ACTION_BTN_TYPE.link,
    },
  ]
 

  const addressModel = () => {
    return (
      <Modal
        isOpen={isOpenAddressModel}
        onOpenChange={onOpenAddressModelChange}
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Address</ModalHeader>
              <ModalBody className="overflow-auto">
                {isAddressPending ? (
                  "Loading..."
                ) : (
                  <div>
                    {addressData && addressData[0]?.Party_Address && (
                      <div className="flex flex-col gap-2">
                        <div className="flex  items-center gap-1 overflow-auto">
                          <FontAwesomeIcon icon={faMapLocationDot} />
                          {/* address */}
                          <Snippet
                            hideSymbol
                            className="w-full"
                            checkIcon={<FontAwesomeIcon icon={faCheckDouble} />} 
                            onCopy={(value) => {
                              copy(value)
                            }}
                          >
                            {addressData[0]?.Party_Address?.split(",").map(
                              (item, index) => {
                                return <span key={index}>{item}</span>
                              }
                            )}
                          </Snippet>
                        </div>
                        <div className="flex  items-center gap-1 overflow-auto">
                          <FontAwesomeIcon icon={faPhone} />
                          {/* contact number */}
                          <Snippet
                            hideSymbol
                            className="w-full"
                            checkIcon={<FontAwesomeIcon icon={faCheckDouble} />}
                            onCopy={(value) => {
                              copy(value)
                            }}
                          >
                            {addressData[0]?.Party_ContectNo?.split(",").map(
                              (item, index) => {
                                return <span key={index}>{item}</span>
                              }
                            )}
                          </Snippet>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Close
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    )
  }

  if (isLoading) {
    return <LoadingCard />
  }

  if (isError || isErrorFetch) {
    return <ErrorCard />
  }

  return (
    <div>
      <MainContainer
        pageName="Party Summary"
        info={[]}
        breadcrumbs={["Payable", "Party Summary"]}
      >
        {addressModel({ data: addressData })}
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          columns={columns}
          exportColumns={exportColumns}
          rowActionBtn={rowActionBtn}
          downloadDataFooter={downloadDataFooter}
          downloadFileName="Payable_Outstanding_Summary"
          showAdvanceFilter={false}
          id="party_summary"
        />
      </MainContainer>
    </div>
  )
}

export default OutPPartySummary
